import React from "react";
import Noti from "../../../util/noti";

import SiteCreationChild from "./SiteCreationChild";
import { ConstructionForm } from "./ConstructionForm";

import { useRouteWithData } from'../../../util/router';
import { Redirect } from 'react-router-dom';

function SiteCreationConstructionForm() {

  const { getData } = useRouteWithData();
  const routeState = getData();

  if(!routeState) {
    return <Redirect to="/solar/administration/site-creation/manage-site/construction-table" />
  }

	return (
		<SiteCreationChild hideNavBar={true} requiredRoles={['administration:SiteCreation:_view']}>
			<ConstructionForm siteInfo={routeState.siteInfo} />
			<Noti />
		</SiteCreationChild>
	);
}

export default SiteCreationConstructionForm;
